import React, { useEffect, useState } from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Loader from '../components/common/Loader';
import { deleteData, getData, getUserData, handleError } from '../functions/services';
import DataTable from 'react-data-table-component';
import * as FaIcons from 'react-icons/fa';
import { sweetAlertToast, sweetQuestion } from '../functions/sweetAlert';
import { formatDateToLocal } from '../functions/dates';
import ModalCompleteSession from '../components/modal/ModalCompleteSession';
import CopyToClipboard from 'react-copy-to-clipboard';
import { getRateSessionURL } from '../functions/sessions';
import { customTableStyles, darkCell, darkCellCenter } from '../constants/data';

const CoachPendingSessions = (props) => {
    const {
        match: {
            params: { id },
        },
    } = props;
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [modalData, setModalData] = useState('');

    const onOpenModal = (data) => {
        setModalData(data);
        setOpenModal(true);
    };
    const onCloseModal = () => setOpenModal(false);

    const loadTable = async () => {
        try {
            setLoading(true);
            const req = await getData(`sessionItems/coach/pending/${getUserData().user.id}`, {});
            setLoading(false);
            setData(req.data);
        } catch (error) {
            console.log(error);
            handleError(error);
        }
    };

    const tableData = () => {
        const columns = [
            {
                name: 'Fecha',
                selector: 'date',
            },
            {
                name: 'Ciudad',
                selector: 'city',
                sortable: true,
            },
            {
                name: 'Cliente',
                selector: 'company',
                sortable: true,
            },
            {
                name: 'Área',
                selector: 'team',
                sortable: true,
                center: true,
            },
            {
                name: 'Horario',
                selector: 'hour',
            },
            {
                name: 'Tipo',
                selector: 'type',
                sortable: true,
            },
            {
                name: 'Acciones',
                selector: 'actions',
                center: true,
            },
        ];

        let tableArray = [];

        searchArray().forEach((val) => {
            const json = {
                id: val.id,
                date: formatDateToLocal(val.date),
                city: val.city,
                company: val.session.company.name,
                team: val.team.name,
                hour: `${val.hourIn} - ${val.hourOut}`,
                type: val.sessionType,
                actions: (
                    <>
                        <span
                            className="pointer"
                            onClick={() => onOpenModal(val)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Completar sessión"
                        >
                            <FaIcons.FaCheckCircle className="table-icon" />
                        </span>
                        <span
                            className="pointer"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Copiar url"
                        >
                            <CopyToClipboard
                                text={getRateSessionURL(val.uuid)}
                                onCopy={() => sweetAlertToast(`URL para la calificación copiada`)}
                            >
                                <FaIcons.FaCopy className="table-icon" />
                            </CopyToClipboard>
                        </span>
                    </>
                ),
            };

            tableArray.push(json);
        });

        return (
            <DataTable
                customStyles={customTableStyles}
                noHeader
                pagination
                columns={columns}
                data={tableArray}
            />
        );
    };

    const onDelete = async (id) => {
        const question = await sweetQuestion('Quieres eliminar este coaching?', null);
        if (question.isConfirmed) {
            try {
                await deleteData('sessions', id);
                loadTable();
            } catch (error) {
                console.log(error);
                handleError(error);
            }
        }
    };

    const searchArray = () => {
        let keys = [
            {
                name: 'date',
            },
            {
                name: 'hourIn',
            },
            {
                name: 'hourOut',
            },
            {
                name: 'session',
                subKey: {
                    name: 'company',
                    subKey: 'name',
                },
            },
            {
                name: 'team',
                subKey: 'name',
            },
        ];

        return data.filter((value) => {
            return keys.reduce((acum, key) => {
                const searchValue = key.subKey
                    ? key.subKey.subKey
                        ? value[key.name][key.subKey.name][key.subKey.subKey]
                        : value[key.name][key.subKey]
                    : value[key.name];
                return acum || searchValue.toString().toLowerCase().includes(search.toLowerCase());
            }, false);
        });
    };

    useEffect(() => {
        loadTable();
    }, []);

    return (
        <div>
            <div className="container-page ">
                <div className="page-title">Sesiones Pendientes</div>

                <div className="card p-3 mt-3 position-static">
                    <div className="d-flex mb-1">
                        <input
                            type="text"
                            className="form-control page-search mr-auto"
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    {loading ? (
                        <div className="center-admin-loader-page">
                            <Loader />
                        </div>
                    ) : (
                        tableData()
                    )}
                </div>
            </div>

            <Modal
                classNames={{ modal: 'modal-size' }}
                open={openModal}
                onClose={onCloseModal}
                center
            >
                <ModalCompleteSession data={modalData} close={onCloseModal} loadTable={loadTable} />
            </Modal>
        </div>
    );
};

export default CoachPendingSessions;
